export enum Module {
  OMM = 1,
  FMM = 2,
  RLSM = 3,
  EMM = 4,
  LILL = 5,
  SSM = 6,
  PPM = 7,
  ODC2M = 8,
  COAM = 9,
}
